"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckEmail = void 0;
class CheckEmail {
    constructor(authenticationService) {
        this.authenticationService = authenticationService;
    }
    execute(request) {
        return this.authenticationService.checkEmail(request);
    }
}
exports.CheckEmail = CheckEmail;
